import { Image, Typography } from '@smartgift/frontend-toolkit';
import React from 'react';
import { Trans } from 'react-i18next';

import { GeneralLayout } from '@hero/layouts';

import * as S from './style';

function OnlyDesktop() {
  return (
    <S.OnlyDesktop>
      <GeneralLayout>
        <Image name="deviceCheck" />
        <S.OnlyDesktopBody>
          <Typography variant="subtitle4">
            <Trans i18nKey="onlyDesktopSubtitle" />
          </Typography>
        </S.OnlyDesktopBody>
      </GeneralLayout>
    </S.OnlyDesktop>
  );
}

export { OnlyDesktop };
